module.exports = __webpack_public_path__ + "img/logo-w.608765ad.png";